/**
 * Length cap for user-entered audience names. Matches the backend rename
 * validator (250 chars). Backend-generated (auto) names are additionally
 * capped at 80 chars server-side — the 250 cap here covers both.
 */
export const AUDIENCE_NAME_MAX_LENGTH = 250;

/**
 * Display text when the audience has no name yet. Shown in the builder's
 * Audience Name card; matches the prototype mockup.
 */
export const AUDIENCE_NAME_PLACEHOLDER = 'Untitled Audience';

/** Inline error shown when the rename input is empty. */
export const AUDIENCE_NAME_EMPTY_ERROR = 'Audience name cannot be empty';
